<!-- Page Content -->
<div id="page-content">
  <div class="container" *ngFor="let faculty of facultyData let i=index">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section id="about">
            <header><h1>About Us</h1></header>
            <img src="{{faculty.images}}">

            <br><br>

            <div class="wow fadeInLeft animated">
              <div class="row">
                <div class="col-md-6">
                  <div class="card vision-back">
                    <div class="card-body">
                      <h5 class="card-title">The Vision</h5>
                      <!-- <h6 class="card-subtitle mb-2 text-muted">Card subtitle</h6>-->

                      <span class="card-text">
                        To be the centre of excellence in all-embracing development of the nation.
                    </span>

                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="card mission-back">
                    <div class="card-body">
                      <h5 class="card-title">The Mission</h5>
                      <!-- <h6 class="card-subtitle mb-2 text-muted">Card subtitle</h6>-->

                      <span class="card-text">
                        To produce quality graduates with professional skills and to generate knowledge in the humanities and social sciences through cutting-edge research.
                      </span>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <p>
              The Faculty of Humanities and Social Sciences is one of the four founding faculties established at the inception of the University of Ruhuna. A committee appointed to investigate the establishment of the university recommended several programs for the Bachelor of Arts degree, including courses in History, Economics, Geography, Sinhala, English, Fine Arts, and Commerce. Additionally, the committee recommended the establishment of a Department of Education to provide postgraduate training for teachers. Among these recommendations, all programs except Fine Arts and Education were initiated at the faculty's establishment.
            </p>
            <p>
              The first Dean of the Faculty of Humanities and Social Sciences was Prof. Amaradasa Weerasinghe. Since then, the faculty has been led by distinguished scholars including Prof. Sucharitha Gamlath, Prof. Sirimal Ranawella, Prof. Danny Atapattu, Prof. Upali Weerakkody, Prof. P. Liyanarachchi, Prof. S. Wawwage, Prof. Sarath Amarasinghe, Prof. R.M. Ranaweera Banda, Prof. P. Hewage, and Prof. Upali Pannilage. The current Dean is Mr. I. Renuka Priyantha.
            </p>
            <p>
              Established in 1978 with an initial student population of 124, the faculty has grown significantly, now hosting nearly 3,000 students. Currently, around 750 new students are admitted annually. At its inception, the Faculty of Humanities and Social Sciences comprised four departments: Economics, Geography, History, and Sinhala. Today, the faculty has expanded to include ten departments, offering a wide range of bachelor’s degrees in various fields within the humanities and social sciences.
            </p>
            <p>
              The Department of Economics offers the Bachelor of Economics (Honors) degree and the Bachelor of Social Statistics (Honors) degree. The Department of History and Archaeology offers the Bachelor of History (Honors) degree. The Department of Pali and Buddhist Studies offers the Bachelor of Pali (Honors) degree, the Bachelor of Buddhist Philosophy (Honors) degree, and the Bachelor of Buddhist Culture (Honors) degree. The Department of Public Policy offers the Bachelor of Political Science (Honors) degree, and the Department of Sociology offers the Bachelor of Sociology (Honors) degree, with programs available in both Sinhala and English mediums. The Department of History and Archaeology also offers the Bachelor of Archaeology (Honors) degree. The Department of English and Linguistics offers the Bachelor of English (Honors) degree. The Department of Geography offers the Bachelor of Geography (Honors) degree, and the Department of Information Technology offers the Bachelor of Information Technology (Honors) degree, both in the English medium. The Department of Sinhala offers the Bachelor of Sinhala (Honors) degree in the Sinhala medium.
            </p>
            <p>
              Additionally, preparations are underway to introduce two new Bachelor of Honors degree programs in Geographic Information Systems and Computational Economics. These four-year programs combine theoretical and practical studies and are designed to align with current job market demands, emphasizing institutional training, information technology, English language proficiency, mathematical and quantitative skills, logical reasoning, personal development, ethics, values, and critical and creative thinking.
            </p>
            <p>
              In collaboration with the Distance and Continuous Education Unit, the faculty also offers a Bachelor of Arts (External) degree, a Diploma in English Language, an Advanced Diploma in English Language, Advanced Certificate in Inclusive Service Delivery for Sustainable Peace and a Diploma in Psychological Counseling. Postgraduate programs are offered in conjunction with the Faculty of Graduate Studies.
            </p>
            <p>
              The Center for Modern Languages and Civilizations within the faculty offers seven Certificate, Advanced Certificate and Diploma courses in Tamil, Hindi, Chinese, French, Japanese, Korean and German Languages.
            </p>
          </section>
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <aside class="news-small" id="news-small">
            <header>
              <h3>Departments & Units</h3>
            </header>
            <div class="section-content" *ngFor="let dept of departmentData let i=index">
              <a routerLink="/department/{{dept.code}}/{{dept.id}}" class="universal-button framed">
                <h3>{{dept.dept_name}} - {{dept.code}}</h3>
                <figure class="date"><i class="fa fa-arrow-right"></i></figure>
              </a><!-- /.universal-button -->
            </div><!-- /.section-content -->

          </aside><!-- /.news-small -->

        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
    </div><!-- /.row -->

  </div><!-- /.container -->
</div>
<!-- end Page Content -->
